import { authHeader } from './auth-header';

export function getHeader() {

  let header = authHeader();
  header["Content-Type"] = 'application/json';

  return header;
}

export function getUploadHeader() {
  let header = authHeader();
  header['content-type'] = 'multipart/form-data';
  return header;
}